var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutubeCircle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.693359,
    width: 30,
    height: 30,
    rx: 15,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3142 12.2317C22.1506 11.6158 21.6687 11.1307 21.0568 10.9661C19.9477 10.667 15.5003 10.667 15.5003 10.667C15.5003 10.667 11.0529 10.667 9.94374 10.9661C9.33184 11.1307 8.84992 11.6158 8.68635 12.2317C8.38916 13.348 8.38916 15.6771 8.38916 15.6771C8.38916 15.6771 8.38916 18.0062 8.68635 19.1225C8.84992 19.7384 9.33184 20.2033 9.94374 20.3679C11.0529 20.667 15.5003 20.667 15.5003 20.667C15.5003 20.667 19.9477 20.667 21.0568 20.3679C21.6687 20.2033 22.1506 19.7384 22.3142 19.1225C22.6114 18.0062 22.6114 15.6771 22.6114 15.6771C22.6114 15.6771 22.6114 13.348 22.3142 12.2317ZM14.0457 17.7918V13.5624L17.7629 15.6771L14.0457 17.7918Z",
    fill: "#143860"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeCircle);
export default __webpack_public_path__ + "static/media/youtube-circle.0dc6048ae3116b364cbdad2c528a9c9e.svg";
export { ForwardRef as ReactComponent };